import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      alignItems: 'center',
      padding: theme.spacing(0, 1.5),
      height: theme.spacing(6),
      border: theme.shape.borderGray60,
      backgroundColor: COLORS.neutral.white,
      borderRadius: theme.shape.borderRadius,

      '&$disabled': {
        backgroundColor: COLORS.gray.gray80,
        color: COLORS.gray.gray50,

        '& $icon': {
          color: COLORS.gray.gray50,
        },
      },

      '&$active': {
        borderColor: COLORS.primary.default,
      },
    },
    disabled: {},
    active: {},

    text: {
      color: COLORS.gray.gray50,
    },
    overlayValue: {},
    icon: {
      fontSize: theme.typography.pxToRem(16),
      marginLeft: 'auto',
    },
  }),
  { name: 'ImageOverlayTextControl' }
);
